import { useState, FC, RefObject } from 'react';

import { AttachmentModal } from './AttachmentModal';
import { StyledAddAttachmentButton } from '../elements';
import CONTENT from '../content.json';

interface IUploaderProps {
  attachmentLoading?: boolean;
  attachmentRef: RefObject<HTMLInputElement>;
  setAddAttachmentVisible(visible: boolean): void;
}

export const AttachmentUploader: FC<IUploaderProps> = ({
  attachmentLoading,
  attachmentRef,
  setAddAttachmentVisible
}) => {
  const [showingModal, setShowingModal] = useState(false);

  const updateModalVisibility = (isVisible: boolean) => {
    if (attachmentLoading) {
      return;
    }

    setAddAttachmentVisible(isVisible);
    setShowingModal(isVisible);
  };

  const showModal = () => updateModalVisibility(true);
  const closeModal = () => updateModalVisibility(false);

  const openFileDialog = () => {
    closeModal();

    // We need to give the modal time to close so we can actually click the file input
    setTimeout(() => {
      attachmentRef.current?.click();
    }, 1);
  };

  return (
    <>
      {showingModal && <AttachmentModal closeModal={closeModal} openFileDialog={openFileDialog} />}
      <StyledAddAttachmentButton onClick={showModal} aria-label={CONTENT.ariaLabels.attachment} />
    </>
  );
};

AttachmentUploader.displayName = 'AttachmentUploader';
